import { DiscountTier } from "./types";

export const applicableTier = (
  tiers: DiscountTier[],
  quantity: number
): DiscountTier | null => {
  let match: DiscountTier | null = null;
  [...(tiers || [])]
    .sort((a, b) => a.minQuantity - b.minQuantity)
    .forEach(tier => {
      if (quantity >= tier.minQuantity) {
        match = tier;
      }
    });
  return match;
};

export const discountedLineTotal = (
  unitPrice: number,
  tiers: DiscountTier[],
  quantity: number
): number => {
  const tier = applicableTier(tiers, quantity);
  if (!tier) {
    return unitPrice * quantity;
  }
  if (tier.kind === "price") {
    const extras = Math.max(quantity - tier.minQuantity, 0);
    return tier.value + extras * unitPrice;
  }
  return unitPrice * (1 - tier.value / 100) * quantity;
};

export const discountedUnitPrice = (
  unitPrice: number,
  tiers: DiscountTier[],
  quantity: number
): number => discountedLineTotal(unitPrice, tiers, quantity) / quantity;

export const firstTierOfferText = (tiers: DiscountTier[]): string | null => {
  if (!tiers || tiers.length === 0) return null;
  const first = [...tiers].sort((a, b) => a.minQuantity - b.minQuantity)[0];
  if (first.kind === "price") {
    return `Buy ${first.minQuantity} for ${first.value}`;
  }
  return `Buy ${first.minQuantity} to get ${first.value}% off`;
};

export const tierOfferText = (tiers: DiscountTier[]): string | null => {
  if (!tiers || tiers.length === 0) {
    return null;
  }
  const parts = [...tiers]
    .sort((a, b) => a.minQuantity - b.minQuantity)
    .map(tier =>
      tier.kind === "price"
        ? `${tier.minQuantity} for ${tier.value}`
        : `${tier.minQuantity}+ save ${tier.value}%`
    );
  return `Volume discount: ${parts.join(", ")}`;
};
